<template>
  <header class="header-global">
    <base-nav class="navbar-main fixed-top bg-white" :class="extraNavClasses" effect="light" expand :type="type">
      <router-link slot="brand" class="navbar-brand mr-lg-5 " to="/">
        <img src="../../public/img/brand/optimized/ehi-latest.png" alt="logo" />
      </router-link>

      <div class="row" slot="content-header" slot-scope="{ closeMenu }">
        <div class="col-6 collapse-brand">
          <a href="https://demos.creative-tim.com/vue-argon-design-system/documentation/">
            <img src="../../public/img/brand/optimized/ehi-latest.png" />
          </a>
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>

      <ul class="navbar-nav navbar-nav-hover align-items-lg-center ml-lg-auto">
        <li class="nav-item">
          <router-link to="/">
            <span class="nav-link-inner--text">Home</span>
          </router-link>
        </li>

        <li class="nav-item">
          <router-link to="/our-products" class="nav-link nav-link-icon" data-toggle="tooltip" title="Our Products">
            <span class="nav-link-inner--text">Our Products</span>
          </router-link>
        </li>

        <li class="nav-item">
          <router-link to="/project-sites" class="nav-link nav-link-icon" data-toggle="tooltip" title="Projects Sites">
            <span class="nav-link-inner--text">Project Sites</span>
          </router-link>
        </li>

        <li class="nav-item">
          <router-link to="/contact-us" class="nav-link nav-link-icon" data-toggle="tooltip" title="Contact Us">
            <span class="nav-link-inner--text">Contact Us</span>
          </router-link>
        </li>
      </ul>
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

let resizeTimeout;
function resizeThrottler(actualResizeHandler) {
  // ignore resize events as long as an actualResizeHandler execution is in the queue
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();

      // The actualResizeHandler will execute at a rate of 15fps
    }, 66);
  }
}

export default {
  name: "app-header",
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
  },
  data() {
    return {
      type: "",
      colorOnScroll: 400,
      currentScrollValue: 0,
      extraNavClasses: "",
      isTransparent: true,
    };
  },
  mounted() {
    document.addEventListener("scroll", this.scrollListener);
  },
  methods: {
    handleScroll() {
      let scrollValue =
        document.body.scrollTop || document.documentElement.scrollTop;
      this.currentScrollValue = scrollValue;

      if (this.colorOnScroll > 0 && scrollValue > this.colorOnScroll) {
        this.extraNavClasses = "sticky shadow-sm";
        this.isTransparent = false;
        this.type = "white";
      } else {
        if (this.extraNavClasses) {
          this.extraNavClasses = "";
          this.isTransparent = true;
          this.type = "";
        }
      }
    },
    scrollListener() {
      resizeThrottler(this.handleScroll);
    },
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollListener);
  },
};
</script>

<style scoped>
.nav-link-inner--text {
  font-weight: 500;
}
</style>
